import { tv } from 'tailwind-variants';

export const floatingListItemVariants = tv({
  variants: {
    disabled: {
      true: '',
      false: '',
    },
    hasCustomContent: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    {
      disabled: false,
      hasCustomContent: false,
      className: 'cursor-pointer hover:bg-state-hover active:bg-state-press',
    },
  ],
});
